export type NbComponentStatus = 'basic' | 'primary' | 'success' | 'warning' | 'danger' | 'info' | 'control';
export type NbComponentOrCustomStatus = NbComponentStatus | string;
